import __request__ from "routing/request";
export function listGrokPatterns() {
  return __request__("GET", "/system/grok", null, {}, {
    "Accept": ["application/json"]
  });
}
export function createPattern(pattern) {
  return __request__("POST", "/system/grok", pattern, {}, {
    "Accept": ["application/json"]
  });
}
export function bulkUpdatePatterns(patterns, importStrategy) {
  return __request__("PUT", "/system/grok", patterns, { "import-strategy": importStrategy }, {
    "Accept": ["application/json"]
  });
}
export function bulkUpdatePatternsFromTextFile(patterns, importStrategy) {
  return __request__("POST", "/system/grok", patterns, { "import-strategy": importStrategy }, {
    "Accept": ["application/json"]
  });
}
export function getPage(sort = "name", page = 1, per_page = 50, query, order = "asc") {
  return __request__("GET", "/system/grok/paginated", null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  });
}
export function testPattern(pattern) {
  return __request__("POST", "/system/grok/test", pattern, {}, {
    "Accept": ["application/json"]
  });
}
export function listPattern(patternId) {
  return __request__("GET", `/system/grok/${patternId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function updatePattern(patternId, pattern) {
  return __request__("PUT", `/system/grok/${patternId}`, pattern, {}, {
    "Accept": ["application/json"]
  });
}
export function removePattern(patternId) {
  return __request__("DELETE", `/system/grok/${patternId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
